import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  Typography,
  Tooltip,
  IconButton,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { UserLoginInfo } from "../../../types/context";
import {
  FeedbackTypesObj,
  PLATFORM_TYPE_TV,
  FEEDBACK_TYPE_FEEDBACK,
  INVOKE_TYPE_MANUAL,
  IProductParams,
  IRemoteBtnSettings,
  FEEDBACK_TYPE_BUGS,
  BannerTypeList,
  TYPE_IMAGE,
  TYPE_TEXT,
  TYPE_NONE,
  PLATFORM_TYPE_BROWSER,
  FEEDBACK_TYPE_AI_SUPPORT,
} from "../../../model";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import HelpIcon from "@mui/icons-material/Help";
import { UserContext } from "../../../context/userContext";
import PreviewIcon from "@mui/icons-material/Preview";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { appLogger, Http } from "../../../utils";
import { withSnackbar } from "../../../utils/common/SnackbarHoc";
// import RichTextEditor from "react-rte";
import Editor from "../../../utils/common/Editor";

import { cloneDeep } from "lodash";

import {
  enableFeedback,
  enableBugReport,
  enableFeatureRequest,
} from "../../../utils/config";
import DOMPurify from "dompurify";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

function GeneralSettings(props: any) {
  appLogger.info({
    infoObj: {
      method: "GeneralSettings",
      component: "add-product",
      fileName: "generalSettings.tsx",
      props: props,
    },
  });
  const {
    productParams,
    setProductParams,
    errMsg,
    setErrMsg,
    setScroll,
    setpreviewScroll,
    sethandleClick,
    setGeneralScroll,
    generalSettingsMandatoryCheck,
  } = props;
  let userEnabledFeatures: any = localStorage.getItem("userenabledFeatures");
  if (userEnabledFeatures) {
    userEnabledFeatures = JSON.parse(userEnabledFeatures);
  }
  const clearErrMsg = (errMsg: any) => {
    if (
      errMsg.feedbackTypeErr &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes.length > 0
    ) {
      const msg = { ...errMsg };
      msg.feedbackTypeErr = null;
      setErrMsg(msg);
    }

    if (
      errMsg.productTitleErr &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings &&
      productParams.products[0].feedbackAgentSettings.title
    ) {
      const msg = { ...errMsg };
      msg.productTitleErr = null;
      setErrMsg(msg);
    }
    if (
      errMsg.uploadFileMaxSizeErr &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings &&
      productParams.products[0].feedbackAgentSettings.uploadFileMaxSize
    ) {
      const msg = { ...errMsg };
      msg.uploadFileMaxSizeErr = null;
      setErrMsg(msg);
    }
    if (
      errMsg.videoAudioMaxDurationErr &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings &&
      productParams.products[0].feedbackAgentSettings.videoAudioMaxDuration
    ) {
      const msg = { ...errMsg };
      msg.videoAudioMaxDurationErr = null;
      setErrMsg(msg);
    }
    if (
      errMsg.remoteBtnsEmptyError &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings &&
      productParams.products[0].feedbackAgentSettings.remoteBtns.length > 0
    ) {
      const getEmptyVal =
        productParams.products[0].feedbackAgentSettings.remoteBtns.filter(
          (data: any) => data.btnId == ""
        );
      if (getEmptyVal.length == 0) {
        const msg = { ...errMsg };
        msg.remoteBtnsEmptyError = null;
        setErrMsg(msg);
      }
    }
    if (
      errMsg.remoteBtnsUniqueBtnIdError &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings &&
      productParams.products[0].feedbackAgentSettings.remoteBtns.length > 0
    ) {
      let hasDuplicate = false;
      const test: any =
        productParams.products[0].feedbackAgentSettings.remoteBtns;
      test
        .map((v: any) => v.btnId)
        .sort()
        .sort((a: any, b: any) => {
          if (a === b) hasDuplicate = true;
        });
      if (!hasDuplicate) {
        const msg = { ...errMsg };
        msg.remoteBtnsUniqueBtnIdError = null;
        setErrMsg(msg);
      }
    }
  };

  const {
    userInfo,
    setBasicDetailAccordianContext,
    GenSettingsAccordianContext,
    setGenSettingsAccordianContext,
    setFbSettingsAccordianContext,
    setBugSettingsAccordianContext,
    setFreqSettingsAccordianContext,
    setEmailSettingsAccordianContext,
    setExttrackingSettingsAccordianContext,
    setWidgAppSettingsAccordianContext,
    setWidgIntgSettingsAccordianContext,
    enabledFeatures,
    setQRSettingsAccordianContext,
  } = useContext(UserContext) as UserLoginInfo;

  const [deleteFileName, setDeleteFileName] = useState("");
  const [disableCuvo, setDisableCuvo] = useState(false);

  const getRichtext = (e: any) => {
    if (productParams) {
      const temp = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings
      ) {
        temp.products[0].feedbackAgentSettings.bannerText = e;
        setProductParams(temp);
      }
    }
  };

  useEffect(() => {
    if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings &&
      productParams.products[0].feedbackAgentSettings.disableCuvo
    ) {
      setDisableCuvo(true);
    }
  }, [productParams]);

  function stripTags(unStripped: any) {
    const parseHTML = new DOMParser().parseFromString(unStripped, "text/html");
    return parseHTML.body.textContent || "";
  }
  const toolbarConfig: any = {
    // Optionally specify the groups to display (displayed in the order listed).
    display: [
      "INLINE_STYLE_BUTTONS",
      "BLOCK_TYPE_BUTTONS",
      "BLOCK_TYPE_DROPDOWN",
      // "HISTORY_BUTTONS",
    ],
    INLINE_STYLE_BUTTONS: [
      { label: "Bold", style: "BOLD", className: "custom-css-class" },
      { label: "Italic", style: "ITALIC" },
      { label: "Underline", style: "UNDERLINE" },
    ],
    BLOCK_TYPE_DROPDOWN: [
      { label: "Normal", style: "unstyled" },
      { label: "Heading Large", style: "header-one" },
      { label: "Heading Medium", style: "header-two" },
      { label: "Heading Small", style: "header-three" },
    ],
    BLOCK_TYPE_BUTTONS: [
      { label: "UL", style: "unordered-list-item" },
      { label: "OL", style: "ordered-list-item" },
    ],
  };

  const selectSize = (event: SelectChangeEvent) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings
      ) {
        temp.products[0].feedbackAgentSettings.uploadFileMaxSize =
          event.target.value;
        setProductParams(temp);
        clearErrMsg(errMsg);
      }
    }
  };

  const selectDuration = (event: SelectChangeEvent) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings
      ) {
        temp.products[0].feedbackAgentSettings.videoAudioMaxDuration =
          event.target.value;
        setProductParams(temp);
        clearErrMsg(errMsg);
      }
    }
  };

  const selectDialog = (event: SelectChangeEvent) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings
      ) {
        let valueArray: any =
          temp.products[0].feedbackAgentSettings.invokeOn || [];
        // valueArray = [...event.target.value];
        valueArray = event.target.value;

        temp.products[0].feedbackAgentSettings.invokeOn = valueArray;
        setProductParams(temp);
      }
    }
  };

  const selectWidget = (event: SelectChangeEvent<any>) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings
      ) {
        let valueArray: any =
          temp.products[0].feedbackAgentSettings.feedbackTypes || [];
        valueArray = [...event.target.value];
        temp.products[0].feedbackAgentSettings.feedbackTypes = valueArray;
        if (temp.products[0].trackingSystem) {
          if (
            valueArray &&
            valueArray.length > 0 &&
            valueArray.includes(FEEDBACK_TYPE_FEEDBACK)
          ) {
            valueArray = valueArray.filter(
              (e: string) => e !== FEEDBACK_TYPE_FEEDBACK
            );
          }
          temp.products[0].trackingSystem.feedbackTypes = valueArray;
          if (valueArray && valueArray.length > 0) {
            valueArray.map((val: string) => {
              if (
                temp.products[0].trackingSystem &&
                temp.products[0].trackingSystem.configs
              ) {
                if (!temp.products[0].trackingSystem.configs[val]) {
                  temp.products[0].trackingSystem.configs[val] = {
                    auth: {},
                    type: "SELF",
                  };
                }
              }
            });
          }
        }
        setProductParams(temp);
        clearErrMsg(errMsg);
      }
    }
  };

  const selectTitle = (e: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings
      ) {
        temp.products[0].feedbackAgentSettings.title = e.target.value;
        setProductParams(temp);
        clearErrMsg(errMsg);
      }
    }
  };

  const handleDisableCuvoWidget = () => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings
      ) {
        if (temp.products[0].feedbackAgentSettings.disableCuvo) {
          setDisableCuvo(false);
        }
        temp.products[0].feedbackAgentSettings.disableCuvo =
          !temp.products[0].feedbackAgentSettings.disableCuvo;
      }
      setProductParams(temp);
    }
  };

  const handleDisableDefaultBtn = () => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings
      ) {
        temp.products[0].feedbackAgentSettings.disableDefaultBtn =
          !temp.products[0].feedbackAgentSettings.disableDefaultBtn;
      }
      setProductParams(temp);
    }
  };

  const handleChangeRemoteBtnSettings = (
    fieldName: string,
    event: any,
    index: number
  ) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.remoteBtns
      ) {
        if (fieldName === "name") {
          temp.products[0].feedbackAgentSettings.remoteBtns[index].name =
            event.target.value;
        }
        if (fieldName === "btnId") {
          temp.products[0].feedbackAgentSettings.remoteBtns[index].btnId =
            event.target.value;
        }
        if (fieldName === "disable") {
          temp.products[0].feedbackAgentSettings.remoteBtns[index].disable =
            !temp.products[0].feedbackAgentSettings.remoteBtns[index].disable;
        }
        setProductParams(temp);
        clearErrMsg(errMsg);
      }
    }
  };

  const deleteRemoteBtnSettings = (index: number) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.remoteBtns
      ) {
        temp.products[0].feedbackAgentSettings.remoteBtns.splice(index, 1);
        setProductParams(temp);
      }
    }
  };

  const selectSubtitle = (e: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings
      ) {
        temp.products[0].feedbackAgentSettings.subtitle = e.target.value;
        setProductParams(temp);
      }
    }
  };

  const selectThankCaption = (e: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings
      ) {
        temp.products[0].feedbackAgentSettings.thanksStr = e.target.value;
        setProductParams(temp);
      }
    }
  };

  const addRemoteBtnSettings = () => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings
      ) {
        if (!temp.products[0].feedbackAgentSettings.remoteBtns) {
          temp.products[0].feedbackAgentSettings.remoteBtns = [];
        }
        temp.products[0].feedbackAgentSettings.remoteBtns.push({
          name: "",
          btnId: "",
          disable: false,
        });
        setProductParams(temp);
      }
    }
  };

  const logoChange = () => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings
      ) {
        temp.products[0].feedbackAgentSettings.showLogo =
          !temp.products[0].feedbackAgentSettings.showLogo;
        setProductParams(temp);
      }
    }
  };
  const captureChange = () => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings
      ) {
        temp.products[0].feedbackAgentSettings.captureSystemDetails =
          !temp.products[0].feedbackAgentSettings.captureSystemDetails;
        setProductParams(temp);
      }
    }
  };

  const emailCheckChange = () => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings
      ) {
        temp.products[0].feedbackAgentSettings.requireEmail =
          !temp.products[0].feedbackAgentSettings.requireEmail;
        setProductParams(temp);
      }
    }
  };

  const scroll = (e: any) => {
    e.stopPropagation();
    setScroll("general");
    handleAccordianChange(true, "basicDetails", "accordian");
    sethandleClick(2);
  };
  const previewscroll = (e: any) => {
    e.stopPropagation();
    setpreviewScroll("general");
    handleAccordianChange(true, "basicDetails", "accordian");
    sethandleClick(1);
  };
  const handleAccordianChange = (value: any, type: any, clickType: any) => {
    appLogger.info({
      infoObj: {
        method: "handleAccordianChange",
        component: "add-product",
        fileName: "generalSettings.tsx",
        accordianChangesData: { value, type },
      },
    });
    setGenSettingsAccordianContext(value);
    setBasicDetailAccordianContext(false);
    setFbSettingsAccordianContext(false);
    setBugSettingsAccordianContext(false);
    setFreqSettingsAccordianContext(false);
    setEmailSettingsAccordianContext(false);
    setExttrackingSettingsAccordianContext(false);
    setWidgAppSettingsAccordianContext(false);
    setWidgIntgSettingsAccordianContext(false);
    setQRSettingsAccordianContext(false);
    if (clickType == "next") {
      if (generalSettingsMandatoryCheck()) {
        if (
          productParams &&
          productParams.products &&
          productParams.products[0] &&
          productParams.products[0].feedbackAgentSettings &&
          productParams.products[0].feedbackAgentSettings.feedbackTypes &&
          productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
            FEEDBACK_TYPE_FEEDBACK
          )
        ) {
          setFbSettingsAccordianContext(true);
        } else if (
          productParams &&
          productParams.products &&
          productParams.products[0] &&
          productParams.products[0].feedbackAgentSettings &&
          productParams.products[0].feedbackAgentSettings.feedbackTypes &&
          productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
            FEEDBACK_TYPE_BUGS
          )
        ) {
          setBugSettingsAccordianContext(true);
        } else if (
          productParams &&
          productParams.products &&
          productParams.products[0] &&
          productParams.products[0].feedbackAgentSettings &&
          productParams.products[0].feedbackAgentSettings.feedbackTypes &&
          productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
            "FEATURE_REQUEST"
          )
        ) {
          setFreqSettingsAccordianContext(true);
        } else {
          setWidgAppSettingsAccordianContext(true);
        }
        setGenSettingsAccordianContext(false);
      }
    }
    if (clickType == "back") {
      setBasicDetailAccordianContext(true);
      setGenSettingsAccordianContext(false);
    }
    setGeneralScroll();
  };
  const renderToolTip = () => {
    let tooltip: any = "";
    if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
        FEEDBACK_TYPE_FEEDBACK
      )
    ) {
      tooltip = "Go to Feedback Settings";
    } else if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
        FEEDBACK_TYPE_BUGS
      )
    ) {
      tooltip = "go to ticket settings";
    } else if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
        "FEATURE_REQUEST"
      )
    ) {
      tooltip = "Go to Feature Request Settings";
    } else {
      tooltip = "Go to Widget Appereance";
    }
    return tooltip;
  };

  function formatFileSize(bytes: number, decimalPoint: number) {
    if (bytes == 0) return "0 Bytes";
    const k = 1000,
      dm = decimalPoint || 2,
      sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
      i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  const handleImgChange = (url: string, dataInfo: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings
      ) {
        temp.products[0].feedbackAgentSettings.bannerImage = url;
        temp.products[0].feedbackAgentSettings.bannerImageReq = dataInfo;
        setProductParams(temp);
      }
    }
  };

  const handleImageChange = (event: any) => {
    const file = event.target.files[0];
    const formUpload = new FormData();
    const size = file.size;
    const mb = 1000;
    const cur = formatFileSize(size, 2);
    if (!cur.includes("Bytes") && !cur.includes("KB")) {
      props.snackbarShowMessage(
        "You must give an image with less then 1MB",
        "error",
        3000
      );
    } else {
      // if (productParams && productParams.products && productParams.products[0] && productParams.products[0].id) {
      formUpload.append("file", file);
      formUpload.append("fileName", file.name);
      // setLoading(true);
      // const resultString = URL.createObjectURL(file);
      // setIcon(resultString);
      const reader = new FileReader();
      // setFileName(file.name);
      let dataInfo;
      reader.onload = function () {
        const [fileType, base64String] = String(reader.result).split("base64,");
        if (!fileType.includes("image")) {
          props.snackbarShowMessage("Invalid image!", "error", 3000);
          return;
        }

        let sanitizedBase64String;
        let sanitizedFile;
        if (fileType.includes("svg")) {
          const sanitizedString = DOMPurify.sanitize(atob(base64String));
          sanitizedBase64String = btoa(sanitizedString);
          sanitizedFile = new Blob([sanitizedString], {
            type: "image/svg+xml",
          });
        } else {
          sanitizedBase64String = base64String;
          sanitizedFile = file;
        }
        const extension = file.name.split(".")[1];
        dataInfo = {
          file: sanitizedBase64String,
          fileName: `banner.${extension}`,
          deleteFileName: "",
        };
        if (deleteFileName && deleteFileName != "") {
          dataInfo.deleteFileName = deleteFileName;
        }
        const resultString = URL.createObjectURL(sanitizedFile);
        handleImgChange(resultString, dataInfo);
        //     file &&
        //       Http.post({
        //         url: `/api/v2/file/banner`,
        //         body: dataInfo,
        //         state: userInfo,
        //       })
        //         .then((response: any) => {
        //           handleImgChange(response.data.Location);
        //           // setImageUrl(response.data.Location);
        //           // setLogoStatus(true);
        //           // setLoading(false);
        //           appLogger.info({
        //             infoObj: {
        //               method: "handleChange",
        //               component: "add-product",
        //               fileName: "generalSettings.tsx",
        //               response: response,
        //             },
        //           });
        //         })
        //         .catch((error) => {
        //           appLogger.error({
        //             errObj: {
        //               method: "handleChange",
        //               component: "add-product",
        //               fileName: "generalSettings.tsx",
        //               err: error,
        //             },
        //           });
        //           // setLoading(false);
        //         });
      };
      reader.onerror = function (event) {
        appLogger.error(
          {
            errObj: {
              method: "handleChange",
              component: "add-product",
              fileName: "generalSettings.tsx",
              event: event,
            },
          },
          "Error uploading img file"
        );
        reader.abort();
      };
      reader.readAsDataURL(file);
      // } else {

      // }
    }
  };

  const handleChangeEvent = (event: any) => {
    event.target.value = null;
  };

  const deleteImage = (logo: string) => {
    // setLoading(true);
    if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].id &&
      productParams.products[0].id != ""
    ) {
      const filenames: string[] = logo.split("/");
      const filename = filenames[filenames.length - 1];
      const dataInfo = {
        deleteFileName: filename,
      };
      setDeleteFileName(filename);
      handleImgChange("", dataInfo);
    } else {
      handleImgChange("", undefined);
    }
  };

  const selectGeneralText = (e: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings
      ) {
        temp.products[0].feedbackAgentSettings.bannerText = e.target.value;
        setProductParams(temp);
        clearErrMsg(errMsg);
        // setrichtextval(
        //   RichTextEditor.createValueFromString(e.target.value, "html")
        // );
      }
    }
  };

  const selectGeneralBanner = (event: SelectChangeEvent) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings
      ) {
        temp.products[0].feedbackAgentSettings.bannerType = event.target.value;
        setProductParams(temp);
        clearErrMsg(errMsg);
      }
    }
  };
  const renderDynamicFeatureMenus = (val: any) => {
    // enableFeedback || enableBugReport || enableFeatureRequest,
    // orgLevelEnableFeature:
    //   userEnabledFeatures?.enableFeedback ||
    //   userEnabledFeatures?.enableBugReport ||
    //   userEnabledFeatures?.enableFeatureRequest,
    switch (val) {
      case "FEEDBACK":
        return (
          enableFeedback &&
          userEnabledFeatures?.enableFeedback && (
            <MenuItem key={val} value={val}>
              {FeedbackTypesObj[val]}
            </MenuItem>
          )
        );
        break;
      case "BUGS":
        return (
          enableBugReport &&
          userEnabledFeatures?.enableBugReport && (
            <MenuItem key={val} value={val}>
              {FeedbackTypesObj[val]}
            </MenuItem>
          )
        );
        break;
      case "FEATURE_REQUEST":
        return (
          enableFeatureRequest &&
          userEnabledFeatures?.enableFeatureRequest && (
            <MenuItem key={val} value={val}>
              {FeedbackTypesObj[val]}
            </MenuItem>
          )
        );
        break;
      default:
      // code block
    }
  };
  const renderDynamicFeatureMenusChip = (value: any) => {
    switch (value) {
      case "FEEDBACK":
        return (
          enableFeedback &&
          userEnabledFeatures?.enableFeedback && (
            <Chip key={value} label={FeedbackTypesObj[value]} />
          )
        );
        break;
      case "BUGS":
        return (
          enableBugReport &&
          userEnabledFeatures?.enableBugReport && (
            <Chip key={value} label={FeedbackTypesObj[value]} />
          )
        );
        break;
      case "FEATURE_REQUEST":
        return (
          enableFeatureRequest &&
          userEnabledFeatures?.enableFeatureRequest && (
            <Chip key={value} label={FeedbackTypesObj[value]} />
          )
        );
        break;
      default:
      // code block
    }
  };
  const [svgContent, setSvgContent] = useState<any>(null);

  useEffect(() => {
    const fetchSvg = async () => {
      const imgPath =
        productParams &&
        productParams.products &&
        productParams.products[0] &&
        productParams.products[0] &&
        productParams.products[0].feedbackAgentSettings &&
        productParams.products[0].feedbackAgentSettings.bannerImage
          ? productParams.products[0].feedbackAgentSettings.bannerImage
          : "";
      // "https://dashboard-cuvo-upload-photos.s3.amazonaws.com/product_6d414070-8396-11ee-a0ed-f3e6d67f790f/Demo1/logo.png";
      const fileExtension = getFileExtension(imgPath);
      if (fileExtension != "svg") {
        setSvgContent(
          productParams &&
            productParams.products &&
            productParams.products[0] &&
            productParams.products[0] &&
            productParams.products[0].feedbackAgentSettings &&
            productParams.products[0].feedbackAgentSettings.bannerImage
            ? productParams.products[0].feedbackAgentSettings.bannerImage
            : ""
        );
      } else {
        try {
          const response = await fetch(
            productParams &&
              productParams.products &&
              productParams.products[0] &&
              productParams.products[0] &&
              productParams.products[0].feedbackAgentSettings &&
              productParams.products[0].feedbackAgentSettings.bannerImage
              ? productParams.products[0].feedbackAgentSettings.bannerImage
              : ""
          );

          if (!response.ok) {
            throw new Error(`Failed to fetch SVG. Status: ${response.status}`);
          }
          const svgText = await response.text();
          setSvgContent(`data:image/svg+xml;base64,${btoa(svgText)}`);
        } catch (error) {
          // console.error("Error fetching SVG:", error);
        }
      }
    };

    fetchSvg();
  }, [productParams]);
  const getFileExtension = (url: any) => {
    const parts = url.split(".");
    if (parts.length > 1) {
      return parts[parts.length - 1];
      // eslint-disable-next-line @typescript-eslint/tslint/config
    } else {
      return null;
    }
  };
  return (
    <Accordion
      expanded={GenSettingsAccordianContext}
      onChange={(e, expanded) => {
        if (expanded) {
          handleAccordianChange(expanded, "basicDetails", "accordian");
        } else {
          handleAccordianChange(expanded, "basicDetails", "accordian");
        }
      }}
    >
      <AccordionSummary aria-controls={"panel1-content"} id={"panel1-header"}>
        <Grid container className="acc-prod-icon">
          <Grid item spacing={2} className="acc-prod-icon">
            general settings
          </Grid>
          <Grid item spacing={3} className="acc-prod-icon">
            <Tooltip title="General Settings Help" placement="bottom">
              <HelpIcon sx={{ mx: 1, fontSize: "20px" }} onClick={scroll} />
            </Tooltip>
          </Grid>
          {/* productParams && productParams.products && productParams.products[0] && 
            productParams.products[0].platform &&  productParams.products[0].platform === PLATFORM_TYPE_TV ?
          <></> :*/}
          <Grid item spacing={3} className="acc-prod-icon">
            <Tooltip title="General Settings Preview" placement="bottom">
              <PreviewIcon
                sx={{ mx: 1, fontSize: "20px" }}
                onClick={previewscroll}
              />
            </Tooltip>{" "}
          </Grid>
        </Grid>
        {errMsg.feedbackTypeErr ||
        errMsg.productTitleErr ||
        errMsg.uploadFileMaxSizeErr ||
        errMsg.videoAudioMaxDurationErr ||
        errMsg.remoteBtnsEmptyError ||
        errMsg.remoteBtnsUniqueBtnIdError ? (
          <div className="err-icon-div">
            <ErrorOutlineIcon />
          </div>
        ) : (
          <></>
        )}
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          {productParams &&
            productParams.products &&
            productParams.products[0] &&
            productParams.products[0].platform != PLATFORM_TYPE_TV && (
              <Grid item xs={12}>
                <FormControl className="custom-select" fullWidth>
                  <InputLabel>Banner Type</InputLabel>
                  <Select
                    labelId="platform-select"
                    id="platform-select"
                    value={
                      productParams &&
                      productParams.products &&
                      productParams.products[0] &&
                      productParams.products[0].feedbackAgentSettings &&
                      productParams.products[0].feedbackAgentSettings.bannerType
                        ? productParams.products[0].feedbackAgentSettings
                            .bannerType
                        : TYPE_NONE
                    }
                    label="platform"
                    onChange={selectGeneralBanner}
                  >
                    {productParams &&
                    productParams.products &&
                    productParams.products[0] &&
                    productParams.products[0].platform == PLATFORM_TYPE_BROWSER
                      ? BannerTypeList.map((e: any, i: any) => (
                          <MenuItem key={e.value} value={e.value}>
                            {e.name}
                          </MenuItem>
                        ))
                      : BannerTypeList.map(
                          (e: any, i: any) =>
                            e.value != TYPE_IMAGE && (
                              <MenuItem key={e.value} value={e.value}>
                                {e.name}
                              </MenuItem>
                            )
                        )}
                  </Select>
                </FormControl>
              </Grid>
            )}
          {productParams &&
            productParams.products &&
            productParams.products[0] &&
            productParams.products[0].platform == PLATFORM_TYPE_BROWSER &&
            productParams.products[0].feedbackAgentSettings &&
            productParams.products[0].feedbackAgentSettings.bannerType &&
            productParams.products[0].feedbackAgentSettings.bannerType ==
              TYPE_IMAGE && (
              <>
                <Grid item xs={12}>
                  <Box sx={{ mt: 2 }}>
                    <Typography className="title">
                      images :{" "}
                      <span className="title-tooltip">
                        (Image size must be less than 1 MB.) (Maximum image
                        dimension should be 300 x 200)
                      </span>
                    </Typography>
                    <Box className="upload-wrap" sx={{ display: "flex" }}>
                      {!(
                        productParams &&
                        productParams.products &&
                        productParams.products[0] &&
                        productParams.products[0] &&
                        productParams.products[0].feedbackAgentSettings &&
                        productParams.products[0].feedbackAgentSettings
                          .bannerImage
                      ) && (
                        <Button
                          variant="outlined"
                          component="label"
                          className="upload-btn"
                          // onChange={(e: any) => setSelectedImage(e.target.files[0])}
                        >
                          <i className="icon-upload" />
                          upload Image
                          <input
                            hidden
                            accept="image/*"
                            onClick={(event) => handleChangeEvent(event)}
                            onChange={(e) => handleImageChange(e)}
                            type="file"
                          />
                        </Button>
                      )}

                      {productParams &&
                        productParams.products &&
                        productParams.products[0] &&
                        productParams.products[0] &&
                        productParams.products[0].feedbackAgentSettings &&
                        productParams.products[0].feedbackAgentSettings
                          .bannerImage && (
                          <Box className="img-preview">
                            <img id="svgImage" src={svgContent} />
                            {/* <img
                              src={
                                productParams &&
                                productParams.products &&
                                productParams.products[0] &&
                                productParams.products[0] &&
                                productParams.products[0]
                                  .feedbackAgentSettings &&
                                productParams.products[0].feedbackAgentSettings
                                  .bannerImage
                                  ? productParams.products[0]
                                      .feedbackAgentSettings.bannerImage
                                  : ""
                              }
                            /> */}
                          </Box>
                        )}

                      {productParams &&
                        productParams.products &&
                        productParams.products[0] &&
                        productParams.products[0] &&
                        productParams.products[0].feedbackAgentSettings &&
                        productParams.products[0].feedbackAgentSettings
                          .bannerImage && (
                          <Tooltip title="Delete Image" placement="top">
                            <i
                              className="icon-delete cursor-pointer"
                              onClick={() =>
                                deleteImage(
                                  productParams.products[0]
                                    .feedbackAgentSettings.bannerImage
                                )
                              }
                            />
                          </Tooltip>
                        )}
                    </Box>
                  </Box>
                </Grid>
              </>
            )}
          {productParams &&
            productParams.products &&
            productParams.products[0] &&
            productParams.products[0].platform != PLATFORM_TYPE_TV &&
            productParams.products[0].feedbackAgentSettings &&
            productParams.products[0].feedbackAgentSettings.bannerType &&
            productParams.products[0].feedbackAgentSettings.bannerType ==
              TYPE_TEXT && (
              <Grid item xs={12}>
                <FormControl className="custom-select" fullWidth>
                  <InputLabel className="richtext">Banner Text</InputLabel>
                  {productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].platform ==
                    PLATFORM_TYPE_BROWSER ? (
                    // <RichTextEditor
                    //   value={richtextval}
                    //   onChange={getRichtext}
                    //   toolbarClassName="richy"
                    //   toolbarConfig={toolbarConfig}
                    // />
                    <Editor
                      updateData={getRichtext}
                      editorData={
                        productParams &&
                        productParams.products &&
                        productParams.products[0] &&
                        productParams.products[0].feedbackAgentSettings
                          ? productParams.products[0].feedbackAgentSettings
                              .bannerText
                          : ""
                      }
                    />
                  ) : (
                    <OutlinedInput
                      type="text"
                      value={
                        productParams &&
                        productParams.products &&
                        productParams.products[0] &&
                        productParams.products[0].feedbackAgentSettings
                          ? stripTags(
                              productParams.products[0].feedbackAgentSettings
                                .bannerText
                            )
                          : ""
                      }
                      onChange={selectGeneralText}
                      id="title-input"
                      label="title"
                    />
                  )}
                </FormControl>
              </Grid>
            )}

          <Grid item xs={12}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                What features of this widget would you use ? :
                <div style={{ display: "inline-block", color: "red" }}>*</div>{" "}
                {errMsg.feedbackTypeErr ? (
                  <div style={{ display: "inline-block", color: "red" }}>
                    {errMsg.feedbackTypeErr}
                  </div>
                ) : (
                  <></>
                )}
              </InputLabel>
              <Select
                labelId="widget-select"
                id="widget-select"
                value={
                  productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings &&
                  productParams.products[0].feedbackAgentSettings.feedbackTypes
                    ? productParams.products[0].feedbackAgentSettings
                        .feedbackTypes
                    : []
                }
                label="widget"
                onChange={selectWidget}
                multiple
                input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                renderValue={(selected: any) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map(
                      (value: any) => renderDynamicFeatureMenusChip(value)
                      // <Chip key={value} label={FeedbackTypesObj[value]} />
                    )}
                  </Box>
                )}
              >
                {FeedbackTypesObj &&
                Object.keys(FeedbackTypesObj).length > 0 &&
                productParams &&
                productParams.products &&
                productParams.products[0] &&
                productParams.products[0].platform &&
                productParams.products[0].platform === PLATFORM_TYPE_TV ? (
                  <MenuItem
                    key={FEEDBACK_TYPE_FEEDBACK}
                    value={FEEDBACK_TYPE_FEEDBACK}
                  >
                    {FeedbackTypesObj[FEEDBACK_TYPE_FEEDBACK]}
                  </MenuItem>
                ) : (
                  Object.keys(FeedbackTypesObj).map((val) => {
                    return renderDynamicFeatureMenus(val);
                  })
                )}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                How will the widget screen be invoked (can select multiple):{" "}
                <div style={{ display: "inline-block", color: "red" }}>*</div>
              </InputLabel>
              <Select
                labelId="dialog-select"
                id="dialog-select"
                value={
                  productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings &&
                  productParams.products[0].feedbackAgentSettings.invokeOn
                    ? productParams.products[0].feedbackAgentSettings.invokeOn
                    : []
                }
                label="dialog"
                onChange={selectDialog}
              >
                <MenuItem key={INVOKE_TYPE_MANUAL} value={INVOKE_TYPE_MANUAL}>
                  {"User manually clicks button or link"}
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                Title for the main widget screen
                <div style={{ display: "inline-block", color: "red" }}>
                  *
                </div>{" "}
                {errMsg.productTitleErr ? (
                  <div style={{ display: "inline-block", color: "red" }}>
                    {errMsg.productTitleErr}
                  </div>
                ) : (
                  <></>
                )}
              </InputLabel>
              <OutlinedInput
                type="text"
                value={
                  productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings &&
                  productParams.products[0].feedbackAgentSettings.title
                    ? productParams.products[0].feedbackAgentSettings.title
                    : ""
                }
                onChange={selectTitle}
                id="title-input"
                label="title"
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                Subtitle below the main widget screen's title
              </InputLabel>
              <OutlinedInput
                type="text"
                value={
                  productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings &&
                  productParams.products[0].feedbackAgentSettings.subtitle
                    ? productParams.products[0].feedbackAgentSettings.subtitle
                    : ""
                }
                onChange={selectSubtitle}
                id="subtitle-input"
                label="subtitle"
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                Short thank you caption displayed after form submission
              </InputLabel>
              <OutlinedInput
                type="text"
                value={
                  productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings &&
                  productParams.products[0].feedbackAgentSettings.thanksStr
                    ? productParams.products[0].feedbackAgentSettings.thanksStr
                    : ""
                }
                onChange={selectThankCaption}
                id="thankCaption-input"
                label="Thank Caption"
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                Maximum size of file to upload{" "}
                <div style={{ display: "inline-block", color: "red" }}>*</div>{" "}
                {errMsg.uploadFileMaxSizeErr ? (
                  <div style={{ display: "inline-block", color: "red" }}>
                    {errMsg.uploadFileMaxSizeErr}
                  </div>
                ) : (
                  <></>
                )}
              </InputLabel>
              <Select
                labelId="size-select"
                id="size-select"
                value={
                  productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings &&
                  productParams.products[0].feedbackAgentSettings
                    .uploadFileMaxSize
                    ? productParams.products[0].feedbackAgentSettings
                        .uploadFileMaxSize
                    : ""
                }
                label="size"
                onChange={selectSize}
              >
                <MenuItem key={200} value={200}>
                  {"200 MB"}
                </MenuItem>
                <MenuItem key={400} value={400}>
                  {"400 MB"}
                </MenuItem>
                <MenuItem key={600} value={600}>
                  {"600 MB"}
                </MenuItem>
                <MenuItem key={800} value={800}>
                  {"800 MB"}
                </MenuItem>
                <MenuItem key={1024} value={1024}>
                  {"1 GB"}
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                Maximum duration of the Audio and Video recordings (In minutes):
                <div style={{ display: "inline-block", color: "red" }}>
                  *
                </div>{" "}
                {errMsg.videoAudioMaxDurationErr ? (
                  <div style={{ display: "inline-block", color: "red" }}>
                    {errMsg.videoAudioMaxDurationErr}
                  </div>
                ) : (
                  <></>
                )}
              </InputLabel>
              <Select
                labelId="duration-select"
                id="duration-select"
                value={
                  productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings &&
                  productParams.products[0].feedbackAgentSettings
                    .videoAudioMaxDuration
                    ? productParams.products[0].feedbackAgentSettings
                        .videoAudioMaxDuration
                    : ""
                }
                label="duration"
                onChange={selectDuration}
              >
                <MenuItem key={0.5} value={0.5}>
                  {"half a minute"}
                </MenuItem>
                <MenuItem key={1} value={1}>
                  {"1 minute"}
                </MenuItem>
                <MenuItem key={1.5} value={1.5}>
                  {"1 and a half minutes"}
                </MenuItem>
                <MenuItem key={2} value={2}>
                  {"2 minutes"}
                </MenuItem>
                <MenuItem key={2.5} value={2.5}>
                  {"2 and a half minutes"}
                </MenuItem>
                <MenuItem key={3} value={3}>
                  {"3 minutes"}
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Box sx={{ display: "flex", flexDirection: "column", mt: 1.5 }}>
          {/*productParams &&
          productParams.products &&
          productParams.products[0] &&
          productParams.products[0].platform && productParams.products[0].platform !== PLATFORM_TYPE_TV &&*/}
          <FormControlLabel
            control={
              <Checkbox
                onChange={emailCheckChange}
                checked={
                  productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings
                    ? productParams.products[0].feedbackAgentSettings
                        .requireEmail
                    : true
                }
                value={
                  productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings
                    ? productParams.products[0].feedbackAgentSettings
                        .requireEmail
                    : true
                }
                color="primary"
              />
            }
            label="Email field is mandatory."
          />
          <FormControlLabel
            control={
              <Checkbox
                onChange={logoChange}
                checked={
                  productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings
                    ? productParams.products[0].feedbackAgentSettings.showLogo
                    : true
                }
                value={
                  productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings
                    ? productParams.products[0].feedbackAgentSettings.showLogo
                    : true
                }
                color="primary"
              />
            }
            label="Show logo on the agent forms."
          />
          <FormControlLabel
            control={
              <Checkbox
                onChange={captureChange}
                value={
                  productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings
                    ? productParams.products[0].feedbackAgentSettings
                        .captureSystemDetails
                    : true
                }
                checked={
                  productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings
                    ? productParams.products[0].feedbackAgentSettings
                        .captureSystemDetails
                    : true
                }
                color="primary"
              />
            }
            label="Automatically capture user's system details."
          />
        </Box>
        {productParams &&
        productParams.products &&
        productParams.products[0] &&
        productParams.products[0].platform &&
        productParams.products[0].platform === PLATFORM_TYPE_TV ? (
          <></>
        ) : (
          <Box sx={{ mt: 2 }}>
            <Card>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={12} className="category-wrap">
                    <Grid item xs={12}>
                      <Typography className="title">
                        Widget Invocation :{" "}
                        {errMsg.remoteBtnsEmptyError ? (
                          <div
                            style={{ display: "inline-block", color: "red" }}
                          >
                            {errMsg.remoteBtnsEmptyError}
                          </div>
                        ) : (
                          <></>
                        )}
                        {errMsg.remoteBtnsUniqueBtnIdError ? (
                          <div
                            style={{ display: "inline-block", color: "red" }}
                          >
                            {errMsg.remoteBtnsUniqueBtnIdError}
                          </div>
                        ) : (
                          <></>
                        )}
                      </Typography>
                    </Grid>
                    <Grid>
                      {productParams &&
                        productParams.products &&
                        productParams.products[0] &&
                        productParams.products[0].feedbackAgentSettings && (
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={handleDisableCuvoWidget}
                                value={
                                  productParams &&
                                  productParams.products &&
                                  productParams.products[0] &&
                                  productParams.products[0]
                                    .feedbackAgentSettings &&
                                  productParams.products[0]
                                    .feedbackAgentSettings.disableCuvo
                                }
                                checked={
                                  productParams &&
                                  productParams.products &&
                                  productParams.products[0] &&
                                  productParams.products[0]
                                    .feedbackAgentSettings &&
                                  productParams.products[0]
                                    .feedbackAgentSettings.disableCuvo
                                }
                                color="primary"
                              />
                            }
                            label="Disable Cuvo Widget"
                          />
                        )}
                    </Grid>

                    {productParams &&
                      productParams.products &&
                      productParams.products[0] &&
                      productParams.products[0].feedbackAgentSettings && (
                        //   <Grid sx={{ alignItems: "center", mb: 2 }}>
                        //   <FormControlLabel
                        //   control={
                        //     <Checkbox
                        //     disabled={disableCuvo}
                        //     defaultChecked={disableCuvo}
                        //       onChange={handleDisableDefaultBtn}
                        //       value={productParams && productParams.products &&
                        //         productParams.products[0] &&
                        //         productParams.products[0].feedbackAgentSettings &&
                        //         productParams.products[0].feedbackAgentSettings.disableDefaultBtn}
                        //       checked={productParams && productParams.products &&
                        //         productParams.products[0] &&
                        //         productParams.products[0].feedbackAgentSettings &&
                        //         productParams.products[0].feedbackAgentSettings.disableDefaultBtn || (disableCuvo)}
                        //       color="primary"
                        //     />
                        //   }
                        //   label="Disable Default Feedback Button"
                        // />
                        //   </Grid>
                        <Grid
                          container
                          spacing={2}
                          sx={{ alignItems: "center", mb: 2, mt: 2 }}
                        >
                          <Grid item xs={4}>
                            <FormControl className="custom-select" fullWidth>
                              <InputLabel>Default Button Name</InputLabel>
                              <OutlinedInput
                                type="text"
                                disabled={disableCuvo}
                                label="Default Button Name"
                                value="Default Feedback Button"
                                // value={
                                //   productParams &&
                                //   productParams.products &&
                                //   productParams.products[0] &&
                                //   productParams.products[0]
                                //     .feedbackAgentSettings &&
                                //   productParams.products[0]
                                //     .feedbackAgentSettings.widgetLookAndFeel
                                //     .text
                                // }
                                readOnly
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={4}>
                            <FormControl className="custom-select" fullWidth>
                              <InputLabel>
                                Default Button Id{" "}
                                <div
                                  style={{
                                    display: "inline-block",
                                    color: "red",
                                  }}
                                >
                                  *
                                </div>{" "}
                              </InputLabel>
                              <OutlinedInput
                                type="text"
                                disabled={disableCuvo}
                                value={"cuvo_btn"}
                                label="Default Button Id"
                                readOnly
                              />
                            </FormControl>
                          </Grid>
                          <Grid
                            item
                            xs={4}
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  disabled={disableCuvo}
                                  defaultChecked={disableCuvo}
                                  onChange={handleDisableDefaultBtn}
                                  value={
                                    productParams &&
                                    productParams.products &&
                                    productParams.products[0] &&
                                    productParams.products[0]
                                      .feedbackAgentSettings &&
                                    productParams.products[0]
                                      .feedbackAgentSettings.disableDefaultBtn
                                  }
                                  checked={
                                    (productParams &&
                                      productParams.products &&
                                      productParams.products[0] &&
                                      productParams.products[0]
                                        .feedbackAgentSettings &&
                                      productParams.products[0]
                                        .feedbackAgentSettings
                                        .disableDefaultBtn) ||
                                    disableCuvo
                                  }
                                  color="primary"
                                />
                              }
                              label="disable"
                            />
                          </Grid>
                        </Grid>
                      )}

                    {productParams &&
                      productParams.products &&
                      productParams.products[0] &&
                      productParams.products[0].feedbackAgentSettings &&
                      productParams.products[0].feedbackAgentSettings
                        .remoteBtns &&
                      productParams.products[0].feedbackAgentSettings.remoteBtns.map(
                        (remoteBtn: IRemoteBtnSettings, index: number) => {
                          return (
                            <Grid
                              container
                              spacing={2}
                              sx={{ alignItems: "center", mb: 2 }}
                            >
                              <Grid item xs={4}>
                                <FormControl
                                  className="custom-select"
                                  fullWidth
                                >
                                  <InputLabel>Remote Button Name</InputLabel>
                                  <OutlinedInput
                                    type="text"
                                    disabled={disableCuvo}
                                    value={remoteBtn.name}
                                    onChange={(event) =>
                                      handleChangeRemoteBtnSettings(
                                        "name",
                                        event,
                                        index
                                      )
                                    }
                                    id={`Remote-name-input_${index}`}
                                    label="Remote Name"
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item xs={4}>
                                <FormControl
                                  className="custom-select"
                                  fullWidth
                                >
                                  <InputLabel>
                                    Remote Button Id{" "}
                                    <div
                                      style={{
                                        display: "inline-block",
                                        color: "red",
                                      }}
                                    >
                                      *
                                    </div>{" "}
                                  </InputLabel>
                                  <OutlinedInput
                                    type="text"
                                    disabled={disableCuvo}
                                    value={
                                      remoteBtn.btnId ? remoteBtn.btnId : ""
                                    }
                                    onChange={(event) =>
                                      handleChangeRemoteBtnSettings(
                                        "btnId",
                                        event,
                                        index
                                      )
                                    }
                                    id={`Remote-id-input_${index}`}
                                    label="Remote Id"
                                  />
                                </FormControl>
                              </Grid>
                              <Grid
                                item
                                xs={4}
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      onChange={(event) =>
                                        handleChangeRemoteBtnSettings(
                                          "disable",
                                          event,
                                          index
                                        )
                                      }
                                      defaultChecked={disableCuvo}
                                      disabled={disableCuvo}
                                      value={remoteBtn && remoteBtn.disable}
                                      checked={
                                        (remoteBtn && remoteBtn.disable) ||
                                        disableCuvo
                                      }
                                      color="primary"
                                    />
                                  }
                                  label="disable"
                                />
                                <IconButton disabled={disableCuvo}>
                                  <CloseIcon
                                    className="cursor-pointer"
                                    onClick={() =>
                                      deleteRemoteBtnSettings(index)
                                    }
                                  />
                                </IconButton>
                              </Grid>
                            </Grid>
                          );
                        }
                      )}
                    <Grid item xs={12} sx={{ mt: 2 }}>
                      <Button
                        type="button"
                        className="add-category-link"
                        fullWidth
                        disabled={disableCuvo}
                        variant="text"
                        sx={{
                          textTransform: "uppercase",
                        }}
                        onClick={() => addRemoteBtnSettings()}
                      >
                        <AddIcon />
                        button / link
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Box>
        )}
        <Grid
          item
          sx={{ mt: 2, p: 0, mb: 0, lineHeight: 0 }}
          xs={12}
          md={12}
          className="acc-prod-footer"
        >
          <>
            {" "}
            <div></div>
          </>
          {/* <Tooltip title="Go to Basic Details" placement="bottom">
            <Button
              size="small"
              className="backbtn"
              onClick={(e: any) => {
                handleAccordianChange(true, "basicDetails", "back");
              }}
            >
              {" "}
              &nbsp;
              <KeyboardArrowLeft />
              <span className="acc-prod-prev-span">Previous :</span>&nbsp;{" "}
              <span>Go to Basic Details</span>
            </Button>
          </Tooltip> */}
          <Tooltip title={renderToolTip()} placement="bottom">
            <Button
              size="small"
              className="nextbtn guideTourFeedbackSettings"
              onClick={(e: any) => {
                handleAccordianChange(true, "basicDetails", "next");
              }}
            >
              &nbsp;<span className="acc-prod-next-span">Next :</span>&nbsp;{" "}
              <span>{renderToolTip()}</span>
              <KeyboardArrowRight />
            </Button>
          </Tooltip>{" "}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}

export default withSnackbar(GeneralSettings);
